export default "__VITE_ASSET__CdErMNno__";